import css from 'styled-jsx/css';

const styles = css.global`#hero-santander-financiamentos {
    max-height: 436px;
}

#hero-santander-financiamentos .ctn-home-24 {
    display: flex;
    flex-direction: column;
    align-items: center;
}

#hero-santander-financiamentos .hero-img {
    margin-bottom: -10px;
}

#hero-santander-financiamentos .hero-contain {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 280px;
}

#hero-santander-financiamentos .hero-contain .hero-selo img {
    width: 169px;
}

#hero-santander-financiamentos .hero-contain .hero-texts {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

#hero-santander-financiamentos .hero-contain .hero-title {
    color: #000;
    font-family: "SantanderCondensed";
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px;
}

#hero-santander-financiamentos .hero-contain .hero-title b {
    color: #EC0000;
    font-family: "SantanderCondensed";
    font-size: 30px;
    font-style: normal;
    font-weight: 400;
    line-height: 30px; /* 100% */
}

#hero-santander-financiamentos .hero-contain .hero-sub-title {
    color: #000;
    font-family: "Santander Micro Text";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

#hero-santander-financiamentos .hero-buttons a {
    margin: 15px auto 0;
    width: 100%;
    max-width: 210px;
    height: 50px;
    border-radius: 80px;
    font-size: 20px;
    font-weight: 600;
    padding-bottom: 5px;
}

@media (min-width: 414px) {
    #hero-santander-financiamentos .hero-contain {
        max-width: 326px;
    }

    #hero-santander-financiamentos .hero-contain .hero-title,
    #hero-santander-financiamentos .hero-contain .hero-title b {
        font-size: 35px;
    }
}

@media (min-width: 600px) {
    #hero-santander-financiamentos .ctn-home-24 {
        flex-direction: row-reverse;
        justify-content: flex-end;
    }

    #hero-santander-financiamentos .hero-img {
        margin-bottom: 0;
        max-width: 410px;
    }

    #hero-santander-financiamentos .hero-img img {
        width: 100%;
        max-width: 452px;
    }

    #hero-santander-financiamentos .hero-contain .hero-selo img {
        width: 231px;
    }

    #hero-santander-financiamentos .hero-contain {
        max-width: 322px;
        width: 100%;
    }

    #hero-santander-financiamentos .hero-buttons a {
        margin: 15px 0 0;
    }
}

@media (min-width: 800px) {
    #hero-santander-financiamentos .ctn-home-24 {
        justify-content: flex-end;
        gap: 50px;
    }

}

@media (min-width: 994px) {
    #hero-santander-financiamentos {
        padding-top: 15px;
    }

    #hero-santander-financiamentos .ctn-home-24 {
        justify-content: space-between;
        gap: 0;
    }

    #hero-santander-financiamentos .hero-img {
        max-width: 100%;
        width: 510px;
    }

    #hero-santander-financiamentos .hero-contain {
        max-width: 602px;
    }

    #hero-santander-financiamentos .hero-contain .hero-selo img {
        width: 332px;
    }

    #hero-santander-financiamentos .hero-contain .hero-title,
    #hero-santander-financiamentos .hero-contain .hero-title b {
        font-size: 63px;
        line-height: 63px;
    }

    #hero-santander-financiamentos .hero-contain .hero-sub-title {
        font-size: 32px;
    }
}

@media (min-width: 1100px) {
    #hero-santander-financiamentos {
        padding-top: 0;
    }
}`;

export default styles;